import { Navigate } from 'react-router-dom';

import { Page } from '@app/components/Page';
import {
  MCP_APPROVAL,
  MCP_APPROVAL_PATH,
  MCP_INTEGRATION_LABEL,
  MCP_INTEGRATION_LEGACY,
  MCP_INTEGRATION_LEGACY_PATH,
  MCP_INTEGRATION_PATH,
  MCP_LOGIN,
  MCP_LOGIN_PATH,
  SETTINGS,
} from '@app/constants/navigation';
import { McpIntegration } from '@app/pages/McpIntegration';
import type { NNavigation } from '@app/types';

// Consent и approval открываются по ссылке из AI-клиента. Page даёт фрейму
// высоту контента и кнопку меню на мобильной ширине, как у страниц billing.
export const mcpPages: NNavigation.Main = [
  {
    key: MCP_LOGIN,
    label: MCP_INTEGRATION_LABEL,
    id: MCP_LOGIN,
    path: MCP_LOGIN_PATH,
    element: (
      <Page disableBreadcrumbs hideBackButton>
        <McpIntegration />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    key: MCP_APPROVAL,
    label: MCP_INTEGRATION_LABEL,
    id: MCP_APPROVAL,
    path: MCP_APPROVAL_PATH,
    element: (
      <Page disableBreadcrumbs hideBackButton>
        <McpIntegration />
      </Page>
    ),
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
  {
    id: MCP_INTEGRATION_LEGACY,
    label: MCP_INTEGRATION_LABEL,
    path: MCP_INTEGRATION_LEGACY_PATH,
    element: <Navigate to={MCP_INTEGRATION_PATH} replace />,
    issidebaritem: 'false',
    sidebarparentid: SETTINGS,
  },
];
